import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from "@chakra-ui/react";
import { useField } from "formik";
import type { ChangeEvent, FC } from "react";
import { useMemo, useCallback } from "react";
import type { InputFieldProps } from "./types";

export * from "./types";

export const InputField: FC<InputFieldProps> = (props) => {
  const { name, label, labelProps, type, onChange, ...rest } = props;

  const [field, meta, helpers] = useField(name);

  const hasError = useMemo(() => {
    return !!meta.touched && !!meta.error;
  }, [meta.error, meta.touched]);

  const onChangeHandler = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.value === "") {
        helpers.setValue(null);
      } else if (type === "number") {
        helpers.setValue(Number(e.target.value));
      } else {
        field.onChange(e);
      }
      onChange?.(e);
    },
    [field, helpers, onChange, type]
  );

  return (
    <FormControl isInvalid={hasError}>
      {!!label && <FormLabel {...labelProps}>{label}</FormLabel>}
      <Input
        type={type}
        {...field}
        value={field.value === null ? "" : field.value}
        onChange={onChangeHandler}
        {...rest}
      />
      {hasError && <FormErrorMessage>{meta.error}</FormErrorMessage>}
    </FormControl>
  );
};
